import LegalPage from "./components/LegalPage";

const content = `
Welcome to IClimbTrees (https://iclimbtrees.com), a free, not-for-profit platform for learning advanced mathematics. IClimbTrees is currently operated as an independent, unincorporated project based in Canada. These Terms of Service ("Terms") govern your use of the platform. By creating an account or using the site, you agree to these Terms.

If you don't agree to these Terms, please don't use IClimbTrees.

## 1. Eligibility

IClimbTrees is intended for adult learners (18 years of age or older). By using the platform, you confirm that you are at least 18 years old.

## 2. The Service

IClimbTrees provides free access to courses, quizzes, and an AI-assisted tutoring feature to help you learn advanced mathematics. The platform is offered on a not-for-profit basis, free of charge, with no guarantee of continued availability of any particular feature.

We may add, change, or remove courses, features, or functionality (including the AI tutor) at any time, without notice.

## 3. Your Account

- You need a Google account to sign in.
- You're responsible for keeping your account secure and for all activity that happens under it.
- You agree to provide accurate information and to notify us if you believe your account has been compromised.
- You may delete your account at any time by contacting us at iclimbtreesmail@gmail.com.

## 4. Your Content

You retain ownership of the notes, highlights, bookmarks, and any other content you create while using IClimbTrees ("Your Content"). By using the platform, you grant us a limited license to store, display, and process Your Content solely for the purpose of providing the service to you (for example, showing you your own notes, or sending your AI questions to our AI provider to generate a response).

We do not claim ownership over Your Content, and we do not use it to train AI models or share it publicly.

## 5. The AI Tutor Feature

Questions you ask the AI tutor are sent to a third-party AI provider (currently OpenAI/ChatGPT) to generate a response. Please keep the following in mind:

- The AI's answers are generated automatically and may occasionally be incomplete, inaccurate, or mistaken — as with any AI system, don't treat its output as authoritative or as a substitute for expert instruction.
- Please don't submit sensitive personal information (like financial account numbers, health information, or government ID numbers) in your questions to the AI tutor.
- We are not liable for decisions you make based on AI-generated content.

## 6. Acceptable Use

When using IClimbTrees, you agree not to:

- Use the platform for any unlawful purpose
- Attempt to gain unauthorized access to other users' accounts or data
- Interfere with or disrupt the platform's operation (e.g., through hacking, scraping at scale, or denial-of-service activity)
- Upload or submit content that is unlawful, abusive, or infringes on someone else's rights
- Use the AI tutor to generate harmful, abusive, or illegal content

We reserve the right to suspend or terminate accounts that violate these Terms.

## 7. No Fees, No Guarantees

IClimbTrees is provided free of charge. We don't charge for access, and we don't currently plan to. Because the platform is offered for free on a not-for-profit basis:

- The service is provided "as is" and "as available," without warranties of any kind, whether express or implied.
- We don't guarantee that the platform will be uninterrupted, error-free, or perfectly secure.
- We don't guarantee any particular learning outcome, certification, or credential from using the platform.

## 8. Limitation of Liability

To the fullest extent permitted by law, IClimbTrees and its operator(s) will not be liable for any indirect, incidental, or consequential damages arising from your use of (or inability to use) the platform, including but not limited to loss of data, loss of progress, or reliance on AI-generated content. Because this is a free, not-for-profit service, our total liability for any claim relating to the platform is limited to the amount you paid us to use it — which, since the platform is free, is $0.

Nothing in these Terms is intended to limit any liability that cannot be limited under applicable law.

## 9. Third-Party Services

IClimbTrees relies on third-party services, including Google (sign-in), Brevo (email delivery), and OpenAI (AI tutoring). Your use of these integrated features is also subject to those providers' own terms, where applicable.

## 10. Changes to the Platform or These Terms

We may update these Terms from time to time as the platform evolves. We'll update the "Last updated" date above when we do. Continued use of IClimbTrees after changes take effect means you accept the updated Terms.

## 11. Termination

You may stop using IClimbTrees and delete your account at any time. We may suspend or terminate access to the platform for any user who violates these Terms, or at our discretion if needed to protect the platform or other users.

## 12. Governing Law

These Terms are governed by the laws of Canada, without regard to conflict-of-law principles, to the extent applicable given that IClimbTrees is not currently a registered legal entity.

## 13. Contact Us

Questions about these Terms? Reach out at:

**Email:** iclimbtreesmail@gmail.com

---

*These Terms are provided as a good-faith description of how IClimbTrees operates and are not a substitute for legal advice.*
`;

export default function TermsPage() {
  return (
    <LegalPage
      title="Terms of Service for IClimbTrees"
      lastUpdated="July 6, 2026"
      content={content}
    />
  );
}
